module.exports = __webpack_public_path__ + "assets/116fdbbdda9881c6ed289b078a42dce5.mp3";